const autocompleteQuery = (type, inject) => `
query ${type}_list($limit: Int, $offset: Int, $filter: String, $order: String) {
    ${type}_list(limit: $limit, offset: $offset, filter: $filter, order: $order) {
        ${type}_count
        ${type}_list {
            id
            name
            ${inject}
        }
    }
}
`;

const autocompleteEnumQuery = (name) => `
query ${name} {
    __type(name: "${name}") {
        enumValues {
            name
        }
    }
}
`;

export { autocompleteQuery as default, autocompleteEnumQuery };
